import {
  AfterViewInit,
  Component,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthGateway } from 'src/app/application/gateway/AuthGateway';
import { UserGateway } from 'src/app/application/gateway/UserGateway';
import { BasicUser } from 'src/app/domain/models/User';
import { Routes } from 'src/app/infrastructure/routes';

import { ExportOfferAd } from 'src/app/domain/models/ExportOffer';
import { ExportOfferGateway } from 'src/app/application/gateway/ExportOfferGateway';
import { MessageService } from 'primeng/api';
import { environment } from 'src/environments/environment';
import { driver } from "driver.js";

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.css' ],
})
export class HomePageComponent implements OnInit, AfterViewInit {
  offers: ExportOfferAd[] = [];
  offersTrimmed: ExportOfferAd[] = [];

  loading: boolean = false;

  responsiveOptions = [
    {
      breakpoint: '1199px',
      numVisible: 1,
      numScroll: 1,
    },
    {
      breakpoint: '991px',
      numVisible: 1,
      numScroll: 1,
    },
    {
      breakpoint: '767px',
      numVisible: 1,
      numScroll: 1,
    },
  ];

  carouselItems = [
    {
      imageUrl:
        '../../../../assets/img/home_carousel/banner/03-Banner-FR-EN_2.png',
      imageUrlEs:
        '../../../../assets/img/home_carousel/banner/03-Banner-FR-SP_2.png',
      btn: 'HomePage.MarketplaceBtn',
      command: (event: any) =>
        this.navigateTo(event, Routes.toDoPage),
      //command: (event: any) => this.goToMarketplace(event),
      urlLink: Routes.toDoPage,
      sectionId: '',
    }
    // {
    //   imageUrl:
    //   '../../../../assets/img/home_carousel/banner/02-Banner-FR-EN_2.png',
    // imageUrlEs:
    //   '../../../../assets/img/home_carousel/banner/02-Banner-FR-SP_2.png',
    //   btn: 'HomePage.MarketplaceBtn',
    //   command: (event: any) =>
    //     this.navigateTo(event, Routes.internationalMarketplacePage),
    //   //this.navigateTo(event, Routes.toDoPage, 'virtual-comex'),
    //   urlLink: Routes.internationalMarketplacePage,
    //   sectionId: '',
    // },
    // {
    //   imageUrl:
    //     '../../../../assets/img/home_carousel/banner/05-Banner-FR-EN_2.png',
    //   imageUrlEs:
    //     '../../../../assets/img/home_carousel/banner/05-Banner-FR-SP_2.png',
    //   btn: 'HomePage.MarketplaceBtn',
    //   command: (event: any) =>
    //     this.navigateTo(event, Routes.virtualProcurementPage),
    //     //this.navigateTo(event, Routes.toDoPage, 'find-and-connect'),
    //   urlLink: Routes.virtualProcurementPage,
    //   sectionId: '',
    // },
    // {
    //   imageUrl:
    //     '../../../../assets/img/home_carousel/banner/06-Banner-FR-EN_2.png',
    //   imageUrlEs:
    //     '../../../../assets/img/home_carousel/banner/06-Banner-FR-SP_2.png',
    //   btn: 'HomePage.MarketplaceBtn',
    //   command: (event: any) =>
    //     this.navigateTo(event, Routes.automatedSettlementsPage),
    //     //this.navigateTo(event, Routes.toDoPage, 'import-program'),
    //   urlLink: Routes.automatedSettlementsPage,
    //   sectionId: '',
    // },
  ];
  carouselItemsMobile = [
    {
      imageUrl:
        '../../../../assets/img/home_carousel/mobile/2-en@102x-8_2.png',
      imageUrlEs:
        '../../../../assets/img/home_carousel/mobile/2-sp@102x-8_2.png',
      btn: 'HomePage.MarketplaceBtn',
      command: (event: any) =>
        this.navigateTo(event, Routes.toDoPage),
      urlLink: Routes.toDoPage,
      sectionId: '',
    },
    {
      imageUrl:
      '../../../../assets/img/home_carousel/mobile/1-en@102x-8_2.png',
    imageUrlEs:
      '../../../../assets/img/home_carousel/mobile/1-sp@102x-8_2.png',
      btn: 'HomePage.MarketplaceBtn',
      urlLink: Routes.toDoPage,
      sectionId: 'virtual-comex',
      command: (event: any) =>
        this.navigateTo(event, Routes.internationalMarketplacePage),
    },
    {
      imageUrl:
        '../../../../assets/img/home_carousel/mobile/3-en@102x-8_2.png',
      imageUrlEs:
        '../../../../assets/img/home_carousel/mobile/3-sp@102x-8_2.png',
      btn: 'HomePage.MarketplaceBtn',
      command: (event: any) =>
        this.navigateTo(event, Routes.virtualProcurementPage),
      urlLink: Routes.virtualProcurementPage,
      sectionId: 'find-and-connect',
    },
    {
      imageUrl:
        '../../../../assets/img/home_carousel/mobile/4-en@102x-8_2.png',
      imageUrlEs:
        '../../../../assets/img/home_carousel/mobile/4-sp@102x-8_2.png',
      btn: 'HomePage.MarketplaceBtn',
      command: (event: any) =>
        this.navigateTo(event, Routes.automatedSettlementsPage),
      urlLink: Routes.automatedSettlementsPage,
      sectionId: 'import-program',
    },
  ];
  carouselToDo = [
    {
      imageUrl: '../../../../assets/img/home_carousel/banner/to_do/01-QH-EN.png',
      imageUrlEs: '../../../../assets/img/home_carousel/banner/to_do/01-QH-SP.png',
      btn: 'HomePage.MarketplaceBtn',
    },
    {
      imageUrl: '../../../../assets/img/home_carousel/banner/to_do/02-QH-EN.png',
      imageUrlEs: '../../../../assets/img/home_carousel/banner/to_do/02-QH-SP.png',
      btn: 'HomePage.MarketplaceBtn',
    },
    {
      imageUrl: '../../../../assets/img/home_carousel/banner/to_do/03-QH-EN.png',
      imageUrlEs: '../../../../assets/img/home_carousel/banner/to_do/03-QH-SP.png',
      btn: 'HomePage.MarketplaceBtn',
    },
  ];
  carouselItemsOld = [
    {
      backgroundColor: '#F1D335',
      imageUrl: '../../../../assets/img/home_carousel/banne_1.png',
      imageUrl2: '../../../../assets/img/home_carousel/duraznos_trim.png',
      message: 'HomePage.BannerCTA1',
      description: 'HomePage.BannerMsg1',
      btn: 'HomePage.MarketplaceBtn',
    },
    {
      backgroundColor: '#3C1A43',
      imageUrl: '../../../../assets/img/home_carousel/UVAS-RED-BANNER.png',
      imageUrl2: '../../../../assets/img/home_carousel/uvas-rojas.png',
      message: 'HomePage.BannerCTA1',
      description: 'HomePage.BannerMsg1',
      btn: 'HomePage.MarketplaceBtn',
    },
    {
      backgroundColor: '#5CA53A',
      imageUrl: '../../../../assets/img/home_carousel/UVAS-VERDES-BANNER.png',
      imageUrl2: '../../../../assets/img/home_carousel/uvas_verdes_trim.png',
      message: 'HomePage.BannerCTA1',
      description: 'HomePage.BannerMsg1',
      btn: 'HomePage.MarketplaceBtn',
    },
  ];

  carouselItemsOld2 = [
    {
      backgroundColor: '#6EA042',
      imageUrl: '../../../../assets/img/home_carousel/apples.png',
      message: 'HomePage.BannerMessage1',
    },
    {
      backgroundColor: '#682472',
      imageUrl:
        '../../../../assets/img/home_carousel/grapes_redglobe_thompson.png',
      message: 'HomePage.BannerMessage2',
    },
    {
      backgroundColor: '#8D2C87',
      imageUrl: '../../../../assets/img/home_carousel/grapes_thompson.png',
      message: 'HomePage.BannerMessage3',
    },
    {
      backgroundColor: '#6EA042',
      imageUrl: '../../../../assets/img/home_carousel/oranges.png',
      message: 'HomePage.BannerMessage4',
    },
    {
      backgroundColor: '#3D1943',
      imageUrl: '../../../../assets/img/home_carousel/blueberries.png',
      message: 'HomePage.BannerMessage5',
    },
    {
      backgroundColor: '#8D2C87',
      imageUrl: '../../../../assets/img/home_carousel/plums.png',
      message: 'HomePage.BannerMessage6',
    },
  ];

  services = [
    {
      message: 'HomePage.ServicesMessage1',
      iconUrl: '../../../../assets/icons/home_icon_1.png',
    },
    {
      message: 'HomePage.ServicesMessage2',
      iconUrl: '../../../../assets/icons/home_icon_2.png',
    },
    {
      message: 'HomePage.ServicesMessage3',
      iconUrl: '../../../../assets/icons/home_icon_3.png',
    },
    {
      message: 'HomePage.ServicesMessage4',
      iconUrl: '../../../../assets/icons/home_icon_4.png',
    },
  ];

  toDo = [
    {
      iconUrl: '../../../../assets/icons/to-do-1.png',
      title: 'HomePage.ToDoTitle1',
      message: 'HomePage.ToDoMessage1',
      url: Routes.processFruztyPage,
    },
    {
      iconUrl: '../../../../assets/icons/to-do-2.png',
      title: 'HomePage.ToDoTitle2',
      message: 'HomePage.ToDoMessage2',
      url:  Routes.infoMarketplaceDirectSalePage
    },
    {
      iconUrl: '../../../../assets/icons/to-do-3.png',
      title: 'HomePage.ToDoTitle3',
      message: 'HomePage.ToDoMessage3',
      url:  Routes.benefitsCommercialFocusPage
    },
  ];

  contactEmail: string = environment.contactEmail;
  mailToUrl: string = 'mailto:' + this.contactEmail;

  agendyUrl: string = 'https://calendly.com/marco-santana-fruzty';

  profile: BasicUser | undefined;

  @ViewChild('carToDo') elementRef: any;

  ngAfterViewInit() {
    this.lang = this.translate.currentLang;
    this.setupObserver();
    this.checkInitialVisibility();  // Comprobamos la visibilidad al cargar la página

    window.addEventListener('scroll', this.checkInitialVisibility, true);
    window.addEventListener('resize', this.checkInitialVisibility, true);
  }

  // No olvides limpiar los listeners
  ngOnDestroy(): void {
    window.removeEventListener('scroll', this.checkInitialVisibility, true);
    window.removeEventListener('resize', this.checkInitialVisibility, true);
  }

  constructor(
    private _router: Router,
    private _authService: AuthGateway,
    private _messageService: MessageService,
    private _exportOfferService: ExportOfferGateway,
    public translate: TranslateService
  ) {
  }

  ngOnInit(): void {
    this.profile = this._authService.getUser();
    this.loadExportOffers();
  }

  loadExportOffers() {
    this.loading = true;
    this._exportOfferService.getAllForMarketPlaceAds().subscribe({
      next: (v) => {
        this.offers = v;
        this.offersTrimmed =
          this.offers.length > 12 ? this.offers.slice(0, 12) : this.offers;

        this.loading = false;
      },
      error: (e) => {
        this.loading = false;
        this._messageService.add({
          severity: 'error',
          summary: this.translate.instant(
            'MessageService.Summary.FailedAction'
          ),
          detail: this.translate.instant(
            'MessageService.ExportOffer.ManyRetrieveError'
          ),
        });
      },
    });
  }

  goToNav(url: string) {
    this._router.navigate(['/' + url]);
  }
  navigateToMarketplace() {
    this._router.navigate(['/' + Routes.externalMarketplace]);
  }
  navigateToInternationalMarketplace() {
    this._router.navigate(['/' + Routes.internationalMarketplacePage]);
  }
  navigateToComex() {
    this._router.navigate(['/' + Routes.toDoPage]);
  }
  navigateToProcurement() {
    this._router.navigate(['/' + Routes.virtualProcurementPage]);
  }
  navigateToSettlements() {
    this._router.navigate(['/' + Routes.automatedSettlementsPage]);
  }
  navigateTo(event: any, urlLink: string, sectionId: string = '') {
    //console.log('section');
    if (event) {
      if (sectionId !== '') {
        window.open('/' + urlLink + '#' + sectionId, '_self');
      } else {
        this._router.navigate(['/' + urlLink]);
      }
    }
  }

  lang: string = '';

  getImageBg(imgEn: string, imgSp: string): string {
    let bgImg = '';

    switch (this.language) {
      case 'en':
        bgImg = imgEn;
        break;

      case 'es':
        bgImg = imgSp;
        break;
    }

    return bgImg;
  }

  get language() {
    return this.translate.currentLang;
  }

  goToMarketplace(event: any) {
    if (event) {
      this._router.navigate(['/' + Routes.externalMarketplace]);
    }
  }

  contactUs(event: any) {
    if (event) {
      window.open(this.mailToUrl);
    }
  }

  goToAgendy(event: any) {
    if (event) {
      window.open(this.agendyUrl);
    }
  }

  sendMail() {
    const mail = 'marco.santana@fruzty.com';
    const subject = 'Consulta desde el sitio web de Fruzty';
    const body = 'Hola, tengo una consulta sobre...';

    window.location.href = `mailto:${mail}?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
  }


  setupObserver() {
    // Creamos el IntersectionObserver
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');  // Añadimos la clase 'visible'
        }
      },
      {
        threshold: 1.0  // El 50% del elemento debe estar visible
      }
    );

    // Seleccionamos todos los elementos con la clase 'fade-in'
    const fadeInElements = document.querySelectorAll('.fade-in-js, .fade-in-up-js, .fade-in-right-js, .fade-in-left-js, .fade-in-up-4-js');
    fadeInElements.forEach((element) => {
      observer.observe(element);
    });
  }

  // Chequeamos manualmente la visibilidad de los elementos en la carga inicial
  checkInitialVisibility = () => {
    const fadeInElements = document.querySelectorAll('.fade-in-js, .fade-in-up-js, .fade-in-right-js, .fade-in-left-js, .fade-in-up-4-js');

    fadeInElements.forEach((element) => {
      const rect = element.getBoundingClientRect();
      const isHalfVisible = rect.top <= window.innerHeight * 0.5 && rect.bottom >= 0;
      const isFullyVisible = rect.top >= 0 && rect.bottom <= window.innerHeight * 0.9 ;

      if (isHalfVisible || isFullyVisible) {
        element.classList.add('visible');
      }
    });
  };

  navigateToDetail(adsCode: string) {
      this._router.navigate(['/'+ Routes.offerDetail, adsCode])
  }
}

